const Menu = [
  {
    path: "/",
    icon: "fa fa-th",
    title: "Inicio",
  },
  {
    path: "/ordenes-pago-precertificados",
    icon: "fas fa-money-check",
    title:
      "Créditos para solicitar precertificado y/o constancias de exportación",
  },
  {
    path: "/Solicitudes-medico",
    icon: "fa fa-address-card",
    title: "Solicitudes",
  },
  {
    path: "/impresiones-medico-veterinario",
    icon: "fa fa-print",
    title: "Impresión",
  },
];

export default Menu;
